import { render, staticRenderFns } from "./ChatConsole.vue?vue&type=template&id=15f24f3e&scoped=true&"
import script from "./ChatConsole.vue?vue&type=script&lang=js&"
export * from "./ChatConsole.vue?vue&type=script&lang=js&"
import style0 from "./ChatConsole.vue?vue&type=style&index=0&id=15f24f3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f24f3e",
  null
  
)

export default component.exports